import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import { withRouter } from "react-router-dom";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(class CardAdminPermissionList extends CardClass {
    static contextType = MainContext;

    renderContent() {
        const rolePermissions = this.context.rolePermissionsIndexed ? Object.values(this.context.rolePermissionsIndexed) : [];
        const roleCountsByPermissionId = rolePermissions.reduce((counts, rolePermission) => {
            const permissionId = rolePermission.permissionId;
            counts[permissionId] = (counts[permissionId] || 0) + 1;
            return counts;
        }, {});

        const rows = Object.values(this.context.permissionsIndexed || {}).map((permission) => ({
            ...permission,
            roleCount: roleCountsByPermissionId[permission.id] ?? 0,
        }));

        return (
            <Table
                search={true}
                columns={[
                    { key: "id", name: "ID", type: "number" },
                    { key: "name", name: "Name", type: "string" },
                    { key: "description", name: "Description", type: "string" },
                    { key: "roleCount", name: "# Roles", type: "number", width: 110 },
                ]}
                sort={[
                    {
                        key: "name",
                        direction: "ascending",
                    },
                ]}
                rows={rows}
                onClick={(permission) => {
                    this.props.history.push({
                        pathname: "/admin/permission/" + permission.id
                    });
                }}
            />
        );
    }
});
